module.exports = __webpack_public_path__ + "static/media/view.landlix.ru_landing_1_.db9071b6.png";